export enum CreateJobOption {
  FromRequisition = 'fromRequisition',
  FromTemplate = 'fromTemplate',
  Duplicate = 'duplicate',
  Blank = 'blank',
}
